import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
})
export class AdminComponent implements OnInit {

  public appPages = [
    { title: 'Inicio', url: '/app', icon: 'home' },
    { title: 'Contratos', url: '/app/contract', icon: 'albums' },
    { title: 'Crear Contrato', url: '/app/createcontract', icon: 'browsers' },
    { title: 'Reportes', url: '/app/reports', icon: 'newspaper' },
    { title: 'Configuración', url: '/app/config', icon: 'settings' },
    { title: 'Salir', url: '/login', icon: 'exit' }
  ];
  
  constructor() { }

  ngOnInit() {
    
  }

}
